import { Stack, Text } from '@lightspeed/design-system-react'

import React from 'react'
import { T } from '@transifex/react'
import { LineItemFulfilmentAddress } from '../../LineItemFulfilmentAddress'
import { useAppSelector } from '../../../../../../state/hooks'
import { selectSaleFulfilmentDetail } from '../../../../../../state/slices/currentSale/currentSaleSlice'
import {
  AddressErrorsStatus,
  useFulfillmentHelper,
} from '../hooks/useFulfillmentHelper'

export const LineItemFulfilmentFixSaleAddressesLegacy: React.FC = () => {
  const fulfilmentDetail = useAppSelector(selectSaleFulfilmentDetail)
  const { getFulfillmentAddressStatus } = useFulfillmentHelper()

  const status = getFulfillmentAddressStatus(fulfilmentDetail)

  const isIncorrectBillingOrIncorrectShippingAddress =
    status === AddressErrorsStatus.INCORRECTSHIPPING_INCORRECTBILLING ||
    status === AddressErrorsStatus.CORRECTSHIPPING_INCORRECTBILLING ||
    status === AddressErrorsStatus.INCORRECTSHIPPING_CORRECTBILLING

  const isEmptyShippingAndCorrectBillingAddress =
    status === AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING

  const isEmptyShippingAndIncorrectBillingAddress =
    status === AddressErrorsStatus.EMPTYSHIPPING_INCORRECTBILLING

  return (
    <Stack space={6}>
      {isIncorrectBillingOrIncorrectShippingAddress && (
        <>
          <Text type="label">
            <h3>
              {status ===
                AddressErrorsStatus.INCORRECTSHIPPING_INCORRECTBILLING && (
                <T
                  _str="Existing address is incorrect"
                  _context="Popover content"
                />
              )}
              {status ===
                AddressErrorsStatus.CORRECTSHIPPING_INCORRECTBILLING && (
                <T
                  _str="Existing billing address is incorrect"
                  _context="Popover content"
                />
              )}
              {status ===
                AddressErrorsStatus.INCORRECTSHIPPING_CORRECTBILLING && (
                <T
                  _str="Existing shipping address is incorrect"
                  _context="Popover content"
                />
              )}
            </h3>
          </Text>

          <Text>
            <T
              _str="Update the address to use it for this sale."
              _context="Popover description"
            />
          </Text>
        </>
      )}
      {(isEmptyShippingAndCorrectBillingAddress ||
        isEmptyShippingAndIncorrectBillingAddress) && (
        <div className="vd-mb8">
          <LineItemFulfilmentAddress
            fulfillmentDetail={fulfilmentDetail}
            isModalOpeningOnError={true}
          />
        </div>
      )}
    </Stack>
  )
}
